const Index = ({
    isSidebarCollapsed,
    handleClick
}:any) => {
    return (<>
     <button className="openbtn" onClick={handleClick}
        style={{ left: isSidebarCollapsed ? '0px' : '-350px' }}
    >☰ </button>
    </>)
};

export default Index;
